import { AcknowledgementStatus } from '../services/generated/models/AcknowledgementStatus';
import { MyAcknowledgementDto } from '../services/generated/models/MyAcknowledgementDto';
import { MyAcknowledgementElementDto } from '../services/generated/models/MyAcknowledgementElementDto';

export class MyAcknowledgementModel implements MyAcknowledgementDto {
  public id: number;
  public created : string;
  public comment: string;
  public deadline: string;
  public elements: MyAcknowledgementElementDto[] | null;
  public url: string;
  public status: AcknowledgementStatus;
  public title: string;
  public statusString: string = "";
 

  constructor(acknowledgement: MyAcknowledgementDto) {
    this.id = acknowledgement.id;
    this.created = acknowledgement.created;
    this.comment = acknowledgement.comment;
    this.title = acknowledgement.title
    this.elements = acknowledgement.elements;
    this.url = acknowledgement.url;
    this.deadline = acknowledgement.deadline;
    this.status = acknowledgement.status;

    Object.defineProperty(this, 'statusString', {
      get() {
        switch (this.status) {
      case AcknowledgementStatus.InProgress:
        return 'In Progress';
      case AcknowledgementStatus.Completed:
        return 'Completed';
      case AcknowledgementStatus.AfterDeadline:
        return 'After Deadline';
        case AcknowledgementStatus.Expired:
          return 'Expired';
      default:
        return '';
    }
      }
    });
  }
}
